import HttpServices from "./HttpServices";

export default {

    async listBubbles() {
        return await HttpServices.get(`/bubble`);
    },

    async createBubble(title, color1, color2) {
        return await HttpServices.post(`/bubble`, {
            title: title,
            color_1: color1,
            color_2: color2
        });
    },

    async editBubble(id, title, color1, color2) {
        return await HttpServices.patch(`/bubble/${id}`, {
            title: title,
            color_1: color1,
            color_2: color2
        });
    }

}


// WEBPACK FOOTER //
// ./src/services/BubbleServices.js